function mapGetOneCollateralCategoryData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListCollateralCategoriesData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOneCollateralCategoryData, mapGetListCollateralCategoriesData };
